import { type TFunction } from "i18next";
import { CheckCircle2, XCircle } from "lucide-react";

import { Badge } from "@/components/ui/badge";

interface ActiveBadgeProps {
  isActive?: boolean | null;
  t: TFunction;
}

const ActiveBadge = ({ isActive, t }: ActiveBadgeProps) => {
  const Icon = isActive ? CheckCircle2 : XCircle;

  return (
    <Badge variant={isActive ? "success" : "destructive"} className="gap-1.5">
      <Icon className="size-3" aria-hidden="true" />
      {t(isActive ? "common.yes" : "common.no")}
    </Badge>
  );
};

export { ActiveBadge };
